module.exports = __webpack_public_path__ + "img/hortonm.27a88f09.jpg";